import { excludeNullOrUndefined } from 'checkout/utils'
import { sum } from 'lib/array/arrayUtils'
import { isBookingProtectionItem, isInstantBookingLEHotelItem } from 'lib/checkout/checkoutUtils'
import createSelector from 'lib/web/createSelector'

export const getBookingProtectionEnabledCheckoutItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): App.Checkout.InstantBookingItem[] => items.filter(isInstantBookingLEHotelItem),
)

export const getBookingProtectionItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): Array<App.Checkout.BookingProtectionItem> => {
    const bookingProtectionItems = items.filter(isBookingProtectionItem)
    return bookingProtectionItems
  },
)

export const getBookingProtectionItemsView = createSelector(
  (state: App.State) => getBookingProtectionItems(state),
  (state: App.State) => state.bookingProtection.quotes,
  (bookingProtectionItems, quotes): App.WithDataStatus<Array<App.Checkout.BookingProtectionItemView>> => {
    let hasRequiredData = true

    if (!quotes) {
      return {
        hasRequiredData,
        data: [],
      }
    }

    const itemViews = bookingProtectionItems.map(item => {
      const quote = Object.values(quotes).find((quote: App.BookingProtectionQuote) => quote.quoteId === item.quoteId)
      if (!quote) {
        hasRequiredData = false
        return null
      }

      const quotePrice = quote.products.reduce((acc: number, curr: App.BookingProtectionProduct) => {
        if (!curr.totalProductPrice) return acc
        return acc + curr.totalProductPrice
      }, 0)

      return {
        itemId: item.itemId,
        price: quotePrice,
        value: 0,
        surcharge: 0,
        propertyFees: 0,
        taxesAndFees: 0,
      }
    }).filter(excludeNullOrUndefined)

    return {
      hasRequiredData,
      data: itemViews,
    }
  },
)

function getBookingProtectionBreakdownItem(item: App.Checkout.BookingProtectionItemView): App.Checkout.ItemBreakdownView {
  return {
    title: 'Cancellation Protection',
    price: item.price,
    itemType: 'bookingProtection',
    additionalInfoText: [],
    additionalElements: [],
    taxesAndFees: item.taxesAndFees,
  }
}

export const getBookingProtectionBreakdownView = createSelector(
  getBookingProtectionItemsView,
  (viewWithStatus): App.WithDataStatus<Array<App.Checkout.PriceBreakdownView>> => {
    if (viewWithStatus.data.length === 0) { return { hasRequiredData: viewWithStatus.hasRequiredData, data: [] } }

    const breakdownItems = viewWithStatus.data.map(getBookingProtectionBreakdownItem)
    const breakdownView = {
      title: 'Cancellation Protection',
      price: sum(breakdownItems, item => item.price || 0),
      additionalInfoText: [],
      additionalElements: [],
      items: [],
      alwaysShowItemPrice: true,
    }

    return {
      hasRequiredData: true,
      data: [breakdownView],
    }
  },
)
